import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './dropdown_folder_item.module.scss';
import { PrimaryButton } from '../../../../../components/button';
import { FolderSelectionType } from '../../../foldersDropdown.types';

type Props = {
  folder: FolderSelectionType;
  onFolderSelect: (folder: FolderSelectionType) => void;
};

export const DropdownFolderItem: FC<Props> = ({ folder, onFolderSelect }) => {
  const onClick = () => {
    onFolderSelect(folder);
  };

  return (
    <li onClick={onClick} title={folder.title} className={styles.item}>
      <span className={styles.label}>{folder.title}</span>
      <div className={styles.button}>
        <PrimaryButton>
          <FormattedMessage id="folders/dropdown/list/item/DropdownFolderItem.tsx/1" />
        </PrimaryButton>
      </div>
    </li>
  );
};
